

























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Checked extends Vue {
  @Prop({ default: '16' }) size!: string;
  @Prop({ default: '#405F7A' }) fillColor!: string;

  get clipPathId(): string {
    return `clip0_${Math.floor(Math.random() * 1000)}_${Date.now()}`;
  }

  get clipPathUrl(): string {
    return `url(#${this.clipPathId})`;
  }

  get pathData(): string {
    return 'M8 1.83301C4.59424 1.83301 1.83333 4.59392 1.83333 7.99967C1.83333 11.4054 4.59424 14.1663 8 14.1663C11.4058 14.1663 14.1667 11.4054 14.1667 7.99967C14.1667 4.59392 11.4058 1.83301 8 1.83301ZM0.833328 7.99967C0.833328 4.04163 4.04195 0.833008 8 0.833008C11.958 0.833008 15.1667 4.04163 15.1667 7.99967C15.1667 11.9577 11.958 15.1663 8 15.1663C4.04195 15.1663 0.833328 11.9577 0.833328 7.99967ZM11.8081 5.1128C12.0034 5.30806 12.0034 5.62464 11.8081 5.8199L7.14143 10.4866C6.94617 10.6818 6.62958 10.6818 6.43432 10.4866L4.31311 8.36536C4.11785 8.1701 4.11785 7.85351 4.31311 7.65825C4.50837 7.46299 4.82495 7.46299 5.02022 7.65825L6.78787 9.42591L11.101 5.1128C11.2962 4.91753 11.6128 4.91753 11.8081 5.1128Z';
  }
}
